import {
    forwardRef,
    useCallback,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import ModalAlt from "../../../components/modal/ModalAlt";
import { ERROR_MSG } from "../../../constants/common";
import { RESET_LOADER, SET_LOADER } from "../../../constants/contexConstant";
import { useContextState } from "../../../context/ContextProvider";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import H3 from "../../../shared/typography/H3";
import H4 from "../../../shared/typography/H4";
import P from "../../../shared/typography/P";
import AccordionItem from "../../../shared/ui/Accordian/AccordionItem";
import Button from "../../../shared/ui/Button";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import LabeledInput from "../../../shared/ui/Form/LabeledInput";
import DraftLabelInput from "./DraftLabelInput";

let SPECIFICATION = {
    solar_pv_modules: "",
    module_mounting_structure: "",
    inverter: "",
    monitoring_boxes: "",
    dc_power_cable: "",
    ac_power_cable: "",
    earthing_electrode: "",
    lighting_arrestor: "",
    connector: "",
    net_meter: "",
};

const LabelQuillMap = {
    onboardingLeasing: "onboardingLeasing",
    tosLoanPurchase: "tosLoanPurchase",
    tosLease: "tosLease",
    termsPurchase: "termsPurchase",
    termsLoan: "termsLoan",
};

const objectKeysBuilder = (object, initialValues) => {
    return Object.fromEntries(
        Object.keys(object).map((key) => [key, initialValues])
    );
};
const specificationOptions = {
    solar_pv_modules: [
        "Waaree Monocrystalline – Half Cut / PERC Above 500 Watts",
        "Adani / Waaree Monocrystalline – Half Cut / PERC Above 500 Watts",
        "Adani Monocrystalline – Half Cut / PERC Above 500 Watts",
        "Premier Energies / Axitec / Equivalent - Monocrystalline – Half Cut Above 500 Watts / 24VDC / 48 VDC",
        "Adani Topcon Bifacial Monocrystalline – Half Cut / PERC Above 500 Watts",
    ],
    inverter: [
        "Waaree ON GRID_NET METER",
        "Sungrow ON GRID_NET METER",
        "Growatt ON GRID_NET METER",
    ],
};

const MasterDataWrapper = forwardRef(
    (
        {
            endpoint,
            updateEndpoint,
            isMasterData = false,
            showButton = true,
            onDataChange,
        },
        ref
    ) => {
        const { dispatch } = useContextState();
        const [serverData, setServerData] = useState("");
        const [openIndex, setOpenIndex] = useState("");
        const [openSpecificationModal, setOpenSpecificationModal] =
            useState(null);

        const [calculator, setCalculator] = useState({
            residential: {
                "0-100": "",
                "100-300": "",
                "300-500": "",
                "500-60000": "",
            },
        });

        const [calculatorError, setCalculatorError] = useState({
            residential: {
                ...objectKeysBuilder(calculator.residential, false),
            },
        });

        const [specifications, setSpecifications] = useState(SPECIFICATION);

        const [specificationsErrorState, setSpecificationsErrorState] =
            useState(objectKeysBuilder(specifications, false));

        const [warranties, setWarranties] = useState({
            solar_pv_modules: "",
            module_power_output: "",
            inverter: "",
            rest_of_system: "",
        });
        const [warrantiesErrorState, setWarrantiesErrorState] = useState(
            objectKeysBuilder(warranties, false)
        );

        const [governmentSubsidy, setGovernmentSubsidy] = useState({
            "residential-society": {
                "0-500": "",
            },
            "individual-homes": {
                "0-2": "",
                "2-3": "",
                "3-500": "",
            },
        });
        const [governmentSubsidyErrorState, setGovernmentSubsidyErrorState] =
            useState({
                "residential-society": {
                    ...objectKeysBuilder(
                        governmentSubsidy["residential-society"],
                        false
                    ),
                },
                "individual-homes": {
                    ...objectKeysBuilder(
                        governmentSubsidy["individual-homes"],
                        false
                    ),
                },
            });

        /* @DESC:: different inputs @habib610 Fri May 02,2025 */
        const [chargesResidentialState, setChargesResidentialState] = useState({
            investor_rate: {
                "5Y": "",
            },
            hypersrot_rate: {
                per_KW: "",
            },
        });

        const [chargesResidentialErrorState, setChargesResidentialErrorState] =
            useState({
                investor_rate: {
                    "5Y": false,
                },
                hypersrot_rate: {
                    per_KW: false,
                },
            });

        /* @DESC:: different @habib610 Fri May 02,2025 */
        const [chargesCommercialState, setChargesCommercialState] = useState({
            investor_rate: {
                "5Y": "",
                "6Y": "",
                "7Y": "",
                "8Y": "",
                "9Y": "",
                "10Y": "",
            },
            hypersrot_rate: {
                per_KW: "",
            },
        });

        const [chargesCommercialErrorState, setChargesCommercialErrorState] =
            useState({
                investor_rate: {
                    ...objectKeysBuilder(
                        chargesCommercialState.investor_rate,
                        false
                    ),
                },
                hypersrot_rate: {
                    per_KW: false,
                },
            });

        const [pricingLoan, setPricingLoan] = useState({
            subsidy: {
                "0-5": "",
                "5-10": "",
                "10-25": "",
                "25-100": "",
                "100-500": "",
            },
            "non-subsidy": {
                "0-5": "",
                "5-10": "",
                "10-25": "",
                "25-100": "",
                "100-500": "",
            },
        });

        const [pricingLoanErrorState, setPricingLoanSubsidyErrorState] =
            useState({
                subsidy: {
                    ...objectKeysBuilder(pricingLoan.subsidy, false),
                },
                "non-subsidy": {
                    ...objectKeysBuilder(pricingLoan["non-subsidy"], false),
                },
            });

        const [pricingLease, setPricingLease] = useState({
            subsidy: {
                "25-100": "",
                "100-500": "",
            },
        });

        const [pricingLeaseErrorState, setPricingLeaseErrorState] = useState({
            subsidy: {
                ...objectKeysBuilder(pricingLoan.subsidy, false),
            },
        });

        /* @DESC:: state ends @habib610 Fri May 02,2025 */

        let getAccordionProps = (name) => {
            return {
                title: name,
                isOpen: openIndex === name,
                onToggle: () => setOpenIndex(openIndex === name ? null : name),
            };
        };

        const handleTwoStepObjectChange = (
            key,
            value,
            stateSetter,
            errorSetter,
            topLevelKey
        ) => {
            const isError = isNaN(value) || !value;
            stateSetter((prev) => ({
                ...prev,
                [topLevelKey]: { ...prev[topLevelKey], [key]: value },
            }));
            errorSetter((prev) => ({
                ...prev,
                [topLevelKey]: { ...prev[topLevelKey], [key]: isError },
            }));
        };

        const handleOneStepObjectChange = (
            key,
            value,
            stateSetter,
            errorSetter
        ) => {
            const isError = !value;
            stateSetter((prev) => ({ ...prev, [key]: value }));
            errorSetter((prev) => ({ ...prev, [key]: isError }));
        };

        const calculatorFields = Object.keys(calculator.residential);
        const specificationFields = Object.keys(specifications);
        const warrantiesFields = Object.keys(warranties);
        const governmentSubsidyIndividualHomes = Object.keys(
            governmentSubsidy["individual-homes"]
        );
        const governmentSubsidyResidentialSociety = Object.keys(
            governmentSubsidy["residential-society"]
        );
        const chargesResidentialStateFieldsInvestorRate = Object.keys(
            chargesResidentialState.investor_rate
        );
        const chargesResidentialStateFieldsHyperSrotrate = Object.keys(
            chargesResidentialState.hypersrot_rate
        );
        const chargesCommercialStateFieldsInvestorRate = Object.keys(
            chargesCommercialState.investor_rate
        );
        const chargesCommercialStateFieldsHyperSrotrate = Object.keys(
            chargesCommercialState.hypersrot_rate
        );
        const pricingLoanSubsidyFields = Object.keys(pricingLoan.subsidy);
        const pricingLoanNonSubsidyFields = Object.keys(
            pricingLoan["non-subsidy"]
        );
        const pricingLeaseSubsidyFields = Object.keys(pricingLease.subsidy);

        /* @DESC:: Modal state @habib610 Sat May 03,2025 */
        const [openDraftModal, setOpenDraftModal] = useState(null);

        /* @DESC:: draft states @habib610 Sat May 03,2025 */
        const [draftValues, setDraftValues] = useState({
            onboardingLeasing: "",
            tosLoanPurchase: "",
            tosLease: "",
            termsPurchase: "",
            termsLoan: "",
        });

        const getQuillSetter = (value) => {
            let key = LabelQuillMap[openDraftModal.label];
            if (key) {
                setDraftValues((prev) => ({ ...prev, [key]: value }));
            }
        };
        useEffect(() => {
            const getCurrentActiveMasterData = async () => {
                try {
                    dispatch({ type: SET_LOADER });
                    let response = await request.authGet({
                        endpoint,
                    });
                    dispatch({ type: RESET_LOADER });

                    let stringifyData = "";
                    if (isMasterData) {
                        stringifyData = response.data.masterData.data;
                    } else {
                        stringifyData = response.data.proposal.data;
                    }
                    setServerData(stringifyData);
                    let data = JSON.parse(stringifyData);

                    setCalculator(data?.calculator);
                    setSpecifications(data?.specification);
                    setWarranties(data?.warranties);
                    setGovernmentSubsidy(data?.government_subsidy);
                    setPricingLoan(data?.pricing?.loan_and_purchase);
                    setPricingLease(data?.pricing?.leasing);
                    setChargesResidentialState(
                        data?.charges["residential-society"]
                    );
                    setChargesCommercialState(data?.charges?.commercial);
                    setDraftValues({
                        onboardingLeasing: data["onboarding-steps"]?.leasing,
                        tosLoanPurchase:
                            data.terms_and_conditions?.loan_and_purchase,
                        tosLease: data.terms_and_conditions?.leasing,
                        termsPurchase: data["payment-terms"]?.purchase,
                        termsLoan: data["payment-terms"].loan,
                    });

                    // endpoint
                } catch (error) {
                    toast.error(typeof error === "string" ? error : ERROR_MSG);
                    dispatch({ type: RESET_LOADER });
                }
            };

            getCurrentActiveMasterData();
        }, [dispatch, endpoint, isMasterData]);

        const hasValidationErrors = useCallback(() => {
            return [
                ...Object.values(calculatorError.residential),
                ...Object.values(specificationsErrorState),
                ...Object.values(warrantiesErrorState),
                ...Object.values(
                    governmentSubsidyErrorState["residential-society"]
                ),
                ...Object.values(
                    governmentSubsidyErrorState["individual-homes"]
                ),
                ...Object.values(chargesResidentialErrorState.investor_rate),
                ...Object.values(chargesResidentialErrorState.hypersrot_rate),
                ...Object.values(chargesCommercialErrorState.investor_rate),
                ...Object.values(chargesCommercialErrorState.hypersrot_rate),
                ...Object.values(pricingLoanErrorState.subsidy),
                ...Object.values(pricingLoanErrorState["non-subsidy"]),
                ...Object.values(pricingLeaseErrorState.subsidy),
                ...Object.values(draftValues).map((val) => !val?.trim()),
            ].some((v) => v === true || v === "");
        }, [
            calculatorError,
            specificationsErrorState,
            warrantiesErrorState,
            governmentSubsidyErrorState,
            chargesResidentialErrorState,
            chargesCommercialErrorState,
            pricingLoanErrorState,
            pricingLeaseErrorState,
            draftValues,
        ]);

        let buildDataObjectAsString = () => {
            let object = {
                calculator: calculator,
                pricing: {
                    loan_and_purchase: pricingLoan,
                    leasing: pricingLease,
                },
                government_subsidy: governmentSubsidy,
                charges: {
                    "residential-society": chargesResidentialState,
                    commercial: chargesCommercialState,
                },
                "payment-terms": {
                    purchase: draftValues.termsPurchase,
                    loan: draftValues.termsLoan,
                },
                "onboarding-steps": {
                    leasing: draftValues.onboardingLeasing,
                },
                specification: specifications,
                warranties: warranties,
                terms_and_conditions: {
                    loan_and_purchase: draftValues.tosLoanPurchase,
                    leasing: draftValues.tosLease,
                },
            };
            return JSON.stringify(object);
        };

        useImperativeHandle(ref, () => ({
            getAllState: () => ({
                isValid: !hasValidationErrors(),
                data: buildDataObjectAsString(),
            }),
        }));

        useEffect(() => {
            if (onDataChange) {
                const dataString = buildDataObjectAsString();
                onDataChange(dataString);
            }
        }, [
            calculator,
            specifications,
            warranties,
            governmentSubsidy,
            chargesResidentialState,
            chargesCommercialState,
            pricingLoan,
            pricingLease,
            draftValues,
        ]);

        const handleSubmit = useCallback(async () => {
            if (hasValidationErrors()) {
                toast.error("Please fix all errors before submitting.");
                return;
            }

            try {
                const reqDataString = buildDataObjectAsString();
                let reqBody = {
                    data: reqDataString,
                };

                if (serverData === reqDataString) {
                    toast.error("Same data can't be submitted");
                } else {
                    dispatch({ type: SET_LOADER });
                    await request.authPost({
                        endpoint: updateEndpoint,
                        body: reqBody,
                    });
                    dispatch({ type: RESET_LOADER });
                    toast.success("success");
                    setServerData(reqDataString);
                }
            } catch (error) {
                toast.error(typeof error === "string" ? error : ERROR_MSG);
                dispatch({ type: RESET_LOADER });
            }
        }, [
            calculator,
            chargesCommercialState,
            chargesResidentialState,
            dispatch,
            draftValues.onboardingLeasing,
            draftValues.termsLoan,
            draftValues.termsPurchase,
            draftValues.tosLease,
            draftValues.tosLoanPurchase,
            governmentSubsidy,
            hasValidationErrors,
            pricingLease,
            pricingLoan,
            serverData,
            specifications,
            updateEndpoint,
            warranties,
        ]);

        return (
            <div>
                <div className="grid grid-cols-1 gap-x-2.4 lg:grid-cols-2 ">
                    <div>
                        {/* @DESC:: Calculator @habib610 Fri May 02,2025 */}
                        <AccordionItem {...getAccordionProps("Calculator")}>
                            <P className="text-primary text-xs font-vietnam mb-2">
                                Residential
                            </P>
                            {calculatorFields.map((field) => (
                                <LabeledInput
                                    key={field}
                                    label={field}
                                    placeholder={`Enter Residential ${field}`}
                                    value={calculator.residential[field]}
                                    onChange={(e) =>
                                        handleTwoStepObjectChange(
                                            field,
                                            e.target.value,
                                            setCalculator,
                                            setCalculatorError,
                                            "residential"
                                        )
                                    }
                                    errorMessage={
                                        calculatorError.residential[field]
                                            ? `Enter a positive number for Calculator ${field}`
                                            : null
                                    }
                                />
                            ))}
                        </AccordionItem>

                        {/* @DESC:: Onboarding steps @habib610 Fri May 02,2025 */}
                        <AccordionItem {...getAccordionProps("Specification")}>
                            {Object.keys(specifications).map((key) => {
                                const isSelectable =
                                    key === "solar_pv_modules" ||
                                    key === "inverter";

                                return (
                                    <>
                                        <LabeledInput
                                            key={key}
                                            component="textarea"
                                            rows="1"
                                            label={key.replace(/_/g, " ")}
                                            placeholder={`Enter Specification ${key.replace(
                                                /_/g,
                                                " "
                                            )}`}
                                            wrapperClassName={
                                                isSelectable
                                                    ? "mb-0 xl:mb-0"
                                                    : ""
                                            }
                                            value={specifications[key]}
                                            onChange={(e) =>
                                                handleOneStepObjectChange(
                                                    key,
                                                    e.target.value,
                                                    setSpecifications,
                                                    setSpecificationsErrorState
                                                )
                                            }
                                            errorMessage={
                                                specificationsErrorState[key]
                                                    ? `Enter Specification ${key.replace(
                                                          /_/g,
                                                          " "
                                                      )}`
                                                    : null
                                            }
                                            disabled={isSelectable}
                                            helper
                                            className={
                                                isSelectable
                                                    ? "cursor-pointer bg-gray-100"
                                                    : ""
                                            }
                                        />
                                        {isSelectable && (
                                            <div
                                                role="button"
                                                onClick={() => {
                                                    setOpenSpecificationModal(
                                                        key
                                                    );
                                                }}
                                            >
                                                <P className=" md:text-sm xl:text-sm text-blue underline cursor-pointer mb-2 xl:mb-3.6">
                                                    {key === "solar_pv_modules"
                                                        ? "Select Pannels"
                                                        : "Select Inverter"}
                                                </P>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                        </AccordionItem>

                        {/* @DESC:: Warranties  @habib610 Fri May 02,2025 */}
                        <AccordionItem {...getAccordionProps("Warranties")}>
                            {warrantiesFields.map((key) => (
                                <LabeledInput
                                    key={key}
                                    label={key.replace(/_/g, " ")}
                                    placeholder={`Enter Warranties ${key.replace(
                                        /_/g,
                                        " "
                                    )}`}
                                    component="textarea"
                                    rows="1"
                                    value={warranties[key]}
                                    onChange={(e) =>
                                        handleOneStepObjectChange(
                                            key,
                                            e.target.value,
                                            setWarranties,
                                            setWarrantiesErrorState
                                        )
                                    }
                                    errorMessage={
                                        warrantiesErrorState[key]
                                            ? `Enter Warranties ${key.replace(
                                                  /_/g,
                                                  " "
                                              )}`
                                            : null
                                    }
                                />
                            ))}
                        </AccordionItem>

                        {/* @DESC:: Government Subsidy @habib610 Sat May 03,2025 */}
                        <AccordionItem
                            {...getAccordionProps("Government Subsidy")}
                        >
                            <P className="text-primary text-xs font-vietnam mb-2">
                                Residential Society
                            </P>

                            {governmentSubsidyResidentialSociety.map(
                                (field) => (
                                    <LabeledInput
                                        key={field}
                                        label={field}
                                        placeholder={`Enter Residential ${field}`}
                                        value={
                                            governmentSubsidy[
                                                "residential-society"
                                            ][field]
                                        }
                                        onChange={(e) =>
                                            handleTwoStepObjectChange(
                                                field,
                                                e.target.value,
                                                setGovernmentSubsidy,
                                                setGovernmentSubsidyErrorState,
                                                "residential-society"
                                            )
                                        }
                                        errorMessage={
                                            governmentSubsidyErrorState[
                                                "residential-society"
                                            ][field]
                                                ? `Enter a positive number for Residential  ${field}`
                                                : null
                                        }
                                    />
                                )
                            )}

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Individual Homes
                            </P>

                            {governmentSubsidyIndividualHomes.map((field) => (
                                <LabeledInput
                                    key={field}
                                    label={field}
                                    placeholder={`Enter Individual homes ${field}`}
                                    value={
                                        governmentSubsidy["individual-homes"][
                                            field
                                        ]
                                    }
                                    onChange={(e) =>
                                        handleTwoStepObjectChange(
                                            field,
                                            e.target.value,
                                            setGovernmentSubsidy,
                                            setGovernmentSubsidyErrorState,
                                            "individual-homes"
                                        )
                                    }
                                    errorMessage={
                                        governmentSubsidyErrorState[
                                            "individual-homes"
                                        ][field]
                                            ? `Enter a positive number for Individual homes ${field}`
                                            : null
                                    }
                                />
                            ))}
                        </AccordionItem>

                        {/* @DESC:: Charges @habib610 Sat May 03,2025 */}
                        <AccordionItem {...getAccordionProps("Charges")}>
                            {/* @DESC:: nested 1 @habib610 Sat May 03,2025 */}
                            <P className="text-primary text-xs font-vietnam mb-2">
                                Residential Society
                            </P>

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Investor Rate
                            </P>

                            {chargesResidentialStateFieldsInvestorRate.map(
                                (field) => (
                                    <LabeledInput
                                        key={field}
                                        label={field}
                                        placeholder={`Enter Investor rate ${field}`}
                                        value={
                                            chargesResidentialState
                                                .investor_rate[field]
                                        }
                                        onChange={(e) =>
                                            handleTwoStepObjectChange(
                                                field,
                                                e.target.value,
                                                setChargesResidentialState,
                                                setChargesResidentialErrorState,
                                                "investor_rate"
                                            )
                                        }
                                        errorMessage={
                                            chargesResidentialErrorState
                                                .investor_rate[field]
                                                ? `Enter a positive number for Investor rate ${field}`
                                                : null
                                        }
                                    />
                                )
                            )}

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Hypersrot Rate
                            </P>

                            {chargesResidentialStateFieldsHyperSrotrate.map(
                                (field) => (
                                    <LabeledInput
                                        key={field}
                                        label={field}
                                        placeholder={`Enter Hypersrot ${field}`}
                                        value={
                                            chargesResidentialState
                                                .hypersrot_rate[field]
                                        }
                                        onChange={(e) =>
                                            handleTwoStepObjectChange(
                                                field,
                                                e.target.value,
                                                setChargesResidentialState,
                                                setChargesResidentialErrorState,
                                                "hypersrot_rate"
                                            )
                                        }
                                        errorMessage={
                                            chargesResidentialErrorState
                                                .hypersrot_rate[field]
                                                ? `Enter a positive number for Hypersrot ${field}`
                                                : null
                                        }
                                    />
                                )
                            )}

                            {/* @DESC:: nested two @habib610 Sat May 03,2025 */}

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Commercial
                            </P>

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Investor Rate
                            </P>

                            {chargesCommercialStateFieldsInvestorRate.map(
                                (field) => (
                                    <LabeledInput
                                        key={field}
                                        label={field}
                                        placeholder={`Enter Investor rate ${field}`}
                                        value={
                                            chargesCommercialState
                                                .investor_rate[field]
                                        }
                                        onChange={(e) =>
                                            handleTwoStepObjectChange(
                                                field,
                                                e.target.value,
                                                setChargesCommercialState,
                                                setChargesCommercialErrorState,
                                                "investor_rate"
                                            )
                                        }
                                        errorMessage={
                                            chargesCommercialErrorState
                                                .investor_rate[field]
                                                ? `Enter a positive number for Investor rate ${field}`
                                                : null
                                        }
                                    />
                                )
                            )}

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Hypersrot Rate
                            </P>

                            {chargesCommercialStateFieldsHyperSrotrate.map(
                                (field) => (
                                    <LabeledInput
                                        key={field}
                                        label={field}
                                        placeholder={`Enter Hypersrot ${field}`}
                                        value={
                                            chargesCommercialState
                                                .hypersrot_rate[field]
                                        }
                                        onChange={(e) =>
                                            handleTwoStepObjectChange(
                                                field,
                                                e.target.value,
                                                setChargesCommercialState,
                                                setChargesCommercialErrorState,
                                                "hypersrot_rate"
                                            )
                                        }
                                        errorMessage={
                                            chargesCommercialErrorState
                                                .hypersrot_rate[field]
                                                ? `Enter a positive number for Hypersrot ${field}`
                                                : null
                                        }
                                    />
                                )
                            )}
                        </AccordionItem>
                    </div>
                    <div>
                        {/* @DESC:: Pricing @habib610 Sat May 03,2025 */}
                        <AccordionItem {...getAccordionProps("Pricing")}>
                            {/* @DESC:: nested 1 @habib610 Sat May 03,2025 */}
                            <P className="text-primary text-xs font-vietnam mb-2">
                                Loan and Purchase
                            </P>

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Subsidy
                            </P>

                            {pricingLoanSubsidyFields.map((field) => (
                                <LabeledInput
                                    key={field}
                                    label={field}
                                    placeholder={`Enter subsidy ${field}`}
                                    value={pricingLoan.subsidy[field]}
                                    onChange={(e) =>
                                        handleTwoStepObjectChange(
                                            field,
                                            e.target.value,
                                            setPricingLoan,
                                            setPricingLoanSubsidyErrorState,
                                            "subsidy"
                                        )
                                    }
                                    errorMessage={
                                        pricingLoanErrorState.subsidy[field]
                                            ? `Enter a positive number for subsidy  ${field}`
                                            : null
                                    }
                                />
                            ))}

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Non Subsidy
                            </P>

                            {pricingLoanNonSubsidyFields.map((field) => (
                                <LabeledInput
                                    key={field}
                                    label={field}
                                    placeholder={`Enter Non Subsidy ${field}`}
                                    value={pricingLoan["non-subsidy"][field]}
                                    onChange={(e) =>
                                        handleTwoStepObjectChange(
                                            field,
                                            e.target.value,
                                            setPricingLoan,
                                            setPricingLoanSubsidyErrorState,
                                            "non-subsidy"
                                        )
                                    }
                                    errorMessage={
                                        pricingLoanErrorState["non-subsidy"][
                                            field
                                        ]
                                            ? `Enter a positive number Non subsidy ${field}`
                                            : null
                                    }
                                />
                            ))}

                            {/* @DESC:: nested two @habib610 Sat May 03,2025 */}
                            <P className="text-primary text-xs font-vietnam mb-2">
                                Leasing
                            </P>

                            <P className="text-primary text-xs font-vietnam mb-2">
                                Subsidy
                            </P>

                            {pricingLeaseSubsidyFields.map((field) => (
                                <LabeledInput
                                    key={field}
                                    label={field}
                                    placeholder={`Enter Investor rate ${field}`}
                                    value={pricingLease.subsidy[field]}
                                    onChange={(e) =>
                                        handleTwoStepObjectChange(
                                            field,
                                            e.target.value,
                                            setPricingLease,
                                            setPricingLeaseErrorState,
                                            "subsidy"
                                        )
                                    }
                                    errorMessage={
                                        pricingLeaseErrorState.subsidy[field]
                                            ? `Enter a positive number for pricing lease subsidy ${field}`
                                            : null
                                    }
                                />
                            ))}
                        </AccordionItem>

                        <AccordionItem
                            {...getAccordionProps("Onboarding steps")}
                        >
                            <DraftLabelInput
                                label={"Leasing"}
                                value={
                                    draftValues[LabelQuillMap.onboardingLeasing]
                                }
                                onClick={() =>
                                    setOpenDraftModal({
                                        label: LabelQuillMap.onboardingLeasing,
                                        heading: "Leasing",
                                    })
                                }
                            />
                        </AccordionItem>

                        <AccordionItem
                            {...getAccordionProps("Terms and Conditions")}
                        >
                            <DraftLabelInput
                                label={"Loan and Purchases"}
                                value={
                                    draftValues[LabelQuillMap.tosLoanPurchase]
                                }
                                onClick={() =>
                                    setOpenDraftModal({
                                        label: LabelQuillMap.tosLoanPurchase,
                                        heading: "Loan and Purchase",
                                    })
                                }
                            />

                            <DraftLabelInput
                                label={"Leasing"}
                                value={draftValues[LabelQuillMap.tosLease]}
                                onClick={() =>
                                    setOpenDraftModal({
                                        label: LabelQuillMap.tosLease,
                                        heading: "Leasing",
                                    })
                                }
                            />
                        </AccordionItem>

                        <AccordionItem {...getAccordionProps("Payment Terms")}>
                            <DraftLabelInput
                                label={"Purchases"}
                                value={draftValues[LabelQuillMap.termsPurchase]}
                                onClick={() =>
                                    setOpenDraftModal({
                                        label: LabelQuillMap.termsPurchase,
                                        heading: "Purchase",
                                    })
                                }
                            />

                            <DraftLabelInput
                                label={"Loan"}
                                value={draftValues[LabelQuillMap.termsLoan]}
                                onClick={() =>
                                    setOpenDraftModal({
                                        label: LabelQuillMap.termsLoan,
                                        heading: "Loan",
                                    })
                                }
                            />
                        </AccordionItem>
                    </div>
                    {showButton && (
                        <div className="fixed lg:hidden bg-white inset-x-0 bottom-6.4 py-2 ">
                            <Container>
                                <Button
                                    className="bg-primary w-full"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                            </Container>
                        </div>
                    )}
                </div>
                {showButton && (
                    <Button
                        className="bg-primary w-full hidden lg:flex text-center "
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                )}

                <ModalAlt
                    isOpen={openDraftModal}
                    onClose={() => setOpenDraftModal(null)}
                    innerTimes={false}
                >
                    <H3 className="text-center">{openDraftModal?.heading}</H3>
                    {openDraftModal && (
                        <div className="mb-4">
                            <ReactQuill
                                theme="snow"
                                value={draftValues[openDraftModal.label]}
                                onChange={getQuillSetter}
                                style={{ height: "200px" }}
                            />
                        </div>
                    )}

                    <Button
                        className="mt-2"
                        onClick={() => setOpenDraftModal(null)}
                    >
                        Submit
                    </Button>
                </ModalAlt>

                <div className="hidden lg:block">
                    {openSpecificationModal && (
                        <ModalAlt
                            isOpen={true}
                            onClose={() => setOpenSpecificationModal(null)}
                            innerTimes={false}
                        >
                            <Container className="bg-white rounded-2xl py-2">
                                <div className="max-h-100 overflow-y-scroll pr-2">
                                    <div className="sticky top-0 bg-white  z-10">
                                        <div className="flex  justify-center bg-gray-100 py-1 rounded-2xl ">
                                            <H4 className="capitalize">
                                                {openSpecificationModal.replace(
                                                    /_/g,
                                                    " "
                                                )}
                                            </H4>
                                        </div>
                                    </div>
                                    <p className="my-1 text-sm">
                                        Please select one of the options from
                                        below
                                    </p>

                                    <ul className="space-y-2">
                                        {specificationOptions[
                                            openSpecificationModal
                                        ]?.map((option, idx) => {
                                            const isSelected =
                                                specifications[
                                                    openSpecificationModal
                                                ] === option;
                                            return (
                                                <li
                                                    key={idx}
                                                    className={`cursor-pointer p-2 rounded border ${
                                                        isSelected
                                                            ? "bg-gray-100"
                                                            : "hover:bg-gray-50"
                                                    }`}
                                                    onClick={() => {
                                                        handleOneStepObjectChange(
                                                            openSpecificationModal,
                                                            option,
                                                            setSpecifications,
                                                            setSpecificationsErrorState
                                                        );
                                                        setOpenSpecificationModal(
                                                            null
                                                        );
                                                    }}
                                                >
                                                    <P className="md:text-sm xl:text-sm">
                                                        {option}
                                                    </P>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </Container>
                        </ModalAlt>
                    )}
                </div>
                <div className="lg:hidden">
                    {openSpecificationModal && (
                        <BottomDrawer
                            isOpen={true}
                            onClick={() => setOpenSpecificationModal(null)}
                            contentClass="min-h-[70vh] rounded-t-4 bg-white"
                            childrenClassName="bg-white"
                            className="z-[104]"
                        >
                            <Container className="bg-white rounded-2xl py-1 mx-0">
                                <div className="max-h-[60vh] overflow-y-scroll pr-2">
                                    <div className="sticky top-0 bg-white  z-10">
                                        <div className="flex  justify-center bg-gray-100 py-1 rounded-2xl ">
                                            <H4 className="capitalize">
                                                {openSpecificationModal.replace(
                                                    /_/g,
                                                    " "
                                                )}
                                            </H4>
                                        </div>
                                    </div>
                                    <p className="my-1 text-sm">
                                        Please select one of the options from
                                        below
                                    </p>

                                    <ul className="space-y-2">
                                        {specificationOptions[
                                            openSpecificationModal
                                        ]?.map((option, idx) => {
                                            const isSelected =
                                                specifications[
                                                    openSpecificationModal
                                                ] === option;
                                            return (
                                                <li
                                                    key={idx}
                                                    className={`cursor-pointer p-2 rounded border ${
                                                        isSelected
                                                            ? "bg-gray-100"
                                                            : "hover:bg-gray-50"
                                                    }`}
                                                    onClick={() => {
                                                        handleOneStepObjectChange(
                                                            openSpecificationModal,
                                                            option,
                                                            setSpecifications,
                                                            setSpecificationsErrorState
                                                        );
                                                        setOpenSpecificationModal(
                                                            null
                                                        );
                                                    }}
                                                >
                                                    <P className="md:text-sm xl:text-sm">
                                                        {option}
                                                    </P>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </Container>
                        </BottomDrawer>
                    )}
                </div>
            </div>
        );
    }
);
export default MasterDataWrapper;
